var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaint40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M13.5,2.5h-1V1.5027C12.5,1.225,12.2749,1,11.9973,1H1.5027C1.2251,1,1,1.225,1,1.5027v2.9946C1,4.7749,1.2251,5,1.5027,5 h10.4946C12.2749,5,12.5,4.7749,12.5,4.4973V3.5H13v3.1021L6.8877,8.0127C6.6606,8.0654,6.5,8.2676,6.5,8.5v1.5074 c-0.2783,0.02-0.5,0.246-0.5,0.5295v2.9261C6,13.7596,6.2404,14,6.5369,14h0.9261C7.7596,14,8,13.7596,8,13.4631v-2.9261 c0-0.2834-0.2217-0.5095-0.5-0.5295v-1.11l6.1123-1.4102C13.8389,7.4351,14,7.2329,14,7V3C14,2.7236,13.7764,2.5,13.5,2.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint40PxSelected);
export default __webpack_public_path__ + "static/media/paint_40px_selected.7d17cd06c0f9cb34ce0744e83f437724.svg";
export { ForwardRef as ReactComponent };